import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IBanner } from '@common/interfaces/banner.interface';
import { BANNER_LIST } from '@common/constants/banners.constants';

@Injectable({ providedIn: 'root' })
export class BannersService {

  banners: IBanner[];

  constructor(private http: HttpClient) {
    this.banners = BANNER_LIST;
  }

  getBanners(section: string): IBanner[] {
    if (!this.banners) {
      return [];
    }

    const now = new Date();

    return this.banners
      .filter(banner => {
        // Must belong to the section
        const inSection = banner.sections.some(s => s.section === section);

        // Must be within date range (if defined)
        const validStart = !banner.dateStart || new Date(banner.dateStart) <= now;
        const validEnd = !banner.dateEnd || new Date(banner.dateEnd) >= now;

        return inSection && validStart && validEnd;
      })
      .sort((a, b) => {
        const orderA = a.sections.find(s => s.section === section)?.order ?? 0;
        const orderB = b.sections.find(s => s.section === section)?.order ?? 0;
        return orderA - orderB;
      });
  }
}
